<template>
  <div :id="`${source}_add_to_lead_or_contact`">
    <a-button v-if="loading" :loading="loading" class="add_container_button">
      Adding...
    </a-button>

    <div
      v-else
      class="flex flex-row w-fit text_color proxima_nova add_container"
    >
      <div
        class="flex items-center text-sm px-2 py-[2px] cursor-pointer border_right"
        @click="handleAddClick(entityTypes.LEAD)"
      >
        Add to leads
      </div>

      <CustomDropdown
        position="end"
        :disabled="loading"
        :relative-to-viewport="true"
      >
        <template #trigger>
          <div class="flex items-center px-1 py-[2px]">
            <ThemeImage
              class="size-5 -rotate-90"
              :icon="imageNames.CHEVRON_ARROW_LEFT_GREY"
              alt="arrow_down"
            />
          </div>
        </template>

        <template #default>
          <div class="flex flex-col">
            <div
              v-for="(option, index) in options"
              :key="`${option?.id}_sequence_${index}`"
              class="dropdown_item"
              @click="handleAddClick(option?.id)"
            >
              {{ option?.text }}
            </div>
          </div>
        </template>
      </CustomDropdown>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { message } from "ant-design-vue";
import { toFetchUsers } from "@/src/utils/userUtils.js";
import { entityTypes } from "@/src/constants/entityTypeConstants.js";

import DashboardService from "@/src/api/DashboardService.js";
import CustomDropdown from "@/src/components/CustomDropdown.vue";
import { imageNames } from "@/src/constants/imageConstants.js";

const props = defineProps({
  source: { type: String, required: true },
  number: { type: String, required: true },
});

const emit = defineEmits(["update:added"]);

const options = [{ id: entityTypes.CONTACT, text: "Add to Contacts" }];

const loading = ref(false);

const handleAddClick = async (type) => {
  try {
    loading.value = true;

    const users = await toFetchUsers();
    const ownerID = users.find(
      (user) => user?.email === localStorage.getItem("userEmail"),
    )?.id;

    const requestData = {
      phone_number: props.number,
      owner_id: ownerID,
    };

    const serviceMethod =
      type === entityTypes.LEAD
        ? DashboardService.addLead
        : DashboardService.addContact;

    const response = await serviceMethod(requestData);

    if (response?.success) {
      const data =
        type === entityTypes.LEAD ? response?.lead : response?.contact;

      message.success(`${props.number} has been added as ${type}`);
      emit("update:added", { ...data, type: type });
    }
  } catch (error) {
    console.error("An error occurred while handling add click: ", error);
  } finally {
    loading.value = false;
  }
};
</script>

<style scoped>
.add_container {
  border-radius: 8px;
  border: 1px solid var(--white-opacity-8);
  background: var(--white-opacity-8);
}

.add_container_button {
  display: flex;
  height: 28px;
  margin: 0;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 8px;
  border: 1px solid var(--white-opacity-8);
  background: var(--white-opacity-8);
}

.add_container_button:hover {
  border: 1px solid var(--white-opacity-8);
}
</style>
